import { render } from "./chat-item.vue?vue&type=template&id=99a4671e&scoped=true"
import script from "./chat-item.vue?vue&type=script&lang=js"
export * from "./chat-item.vue?vue&type=script&lang=js"

import "./chat-item.vue?vue&type=style&index=0&id=99a4671e&scoped=true&lang=css"

import exportComponent from "C:\\Project\\VuePro\\DTP\\dtp_index\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99a4671e"]])

export default __exports__